export default "__VITE_ASSET__CZyS0UZp__"